module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAUCAYAAAHKAjy6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAR1JREFUeNpiYIAAAxDxH0QwQUUYAAIIA/yHSwEEEDMQzwfiDUDMCMQOMN33gbgAxAYIIGR9DsxQEZDSeJzGNzAguwUggJBBAlT/eWRV/3G5kgWZg8QuRBc8D3UwjP+fEcppxGJsPUAA4XUyDAggGfkfObRAnApoiG2EhhgjTmNg4rjjAimi3iPZ9x9dEuQgQWS7QAAWQoJQ3SCQiC75AapLAMoGA5DAfiA+iM1BAAGGDwRANcIc2YDNJwpQCWQfxUPjgxGbqYx40gE+0AizEWYyMRgldJDTaj+UfQHqBQEouxCbHxmQEh8s3B2gIdoIzT0N+DQugGoAJUhHqE3rkeRwakyExrgANITXQ8VAfnuALXkgA1AKCCQUrGRHBwCYI0FGiBUH4gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-invites.png
// module id = 1447
// module chunks = 47